import AxiosAdminAPI from "../../../../util/AxiosAdminAPI";
import EnterpriseComponent from "../../EnterpriseComponent";
import {V1PrivilegeIDOCToArray} from "../../../../util/Payload";

class PrivilegeEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, _) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocResponse = this.getIDOCResponse() ?? "v1.Privilege-001";

        AxiosAdminAPI({
            method: "GET",
            url: "t6/v1/privileges",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
                "Name": this.getAttributeValue("Name"),
                "ParentUSID": this.getAttributeValue("ParentUSID"),
            },
            headers: {
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1PrivilegeIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

}

export default PrivilegeEnterpriseComponent;